module.exports = __webpack_public_path__ + "img/3.7fd1474c.png";